import { render, staticRenderFns } from "./DpApplicationPhoneNumberField.vue?vue&type=template&id=5c14e51e&scoped=true&"
import script from "./DpApplicationPhoneNumberField.vue?vue&type=script&lang=js&"
export * from "./DpApplicationPhoneNumberField.vue?vue&type=script&lang=js&"
import style0 from "./DpApplicationPhoneNumberField.vue?vue&type=style&index=0&id=5c14e51e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c14e51e",
  null
  
)

export default component.exports